module.exports = "/newsfeed/components/newsfeed-header-cf9fc4.html";